import get from 'lodash/get';

export function hasError(errors: unknown, touched: unknown, field: string): boolean {
  return !!(get(errors, field) && get(touched, field));
}
